import React, { useState, useEffect } from 'react';
import axios from '../Axiosinstance';
import { CLOUDINARY_UPLOAD_PRESET, baseURL, timestamp } from '../common';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Webhead from '../website/Webhead';
import qq from './img/qq.jpeg'
import {
    TextField, Button, Grid, CircularProgress, Slide, Typography, Container, MenuItem, Modal, Box, TableContainer, Select, InputLabel, FormControl, IconButton, Paper, Dialog, DialogActions, DialogContent, DialogTitle, RadioGroup, FormControlLabel, Radio, Card, CardContent, Tooltip, Table, Checkbox, TableRow, TableBody, TableCell, TableHead, Menu, Snackbar, Alert
} from '@mui/material';
import Webfooter from './Webfoot'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';



const Elearn = () => {
    const CLOUDINARY_URL = baseURL;
    const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [profilePicture, setProfilePicture] = useState(null);
    const [nricDocument, setNricDocument] = useState(null);
    const [educationDocument, setEducationDocument] = useState(null);
    const [passportDocument, setPassportDocument] = useState(null);
    const [courses, setCourses] = useState([]);
    const [showEmploymentFields, setShowEmploymentFields] = useState(false); // State to manage visibility of employment fields
    const [open, setOpen] = useState(false);
    const [submissionSuccess, setSubmissionSuccess] = useState(false);
    const [batches, setBatches] = useState([]);
    const navigate = useNavigate();
    const [studentData, setStudentData] = useState({
        name: '',
        nric: '',
        email: '',
        phone: '',
        gender: '',
        dob: '',
        password: '',
        officephone: '',
        address: '',
        course: '',
        startModulus: null,
        citizenship: '',
        postalcode: '',
        race: '',
        education: '',
        employmentstatus: '',
        salary: '',
        companyname: '',

        designation: '',
        profileUrl: '',
        batchId: null,
        martialStatus: '',
        status: false,
        passport: '',
        passportExpiryDate: '',
        fatherName: '',
        brotherName: '',
        fatherPhoneNo: '',
        brotherPhoneNo: '',
        religion: '',
        currentAddress: '',
        institutionDetails: [],
        workExpirences: [],
        nricdoc: '',
        educationdoc: '',
        passportdoc: '',
        relationship: '',
        proofType: '',
    });


    useEffect(() => {
        const fetchBatches = async () => {
            try {
                const response = await axios.get("batch-summary"); // API endpoint to get batches
                setBatches(response.data);
            } catch (error) {
                console.error("Error fetching batches:", error);
            }
        };

        fetchBatches();
    }, []);






    const [errors, setErrors] = useState({
        name: "",
        fatherName: "",
        brotherName: "",
        // course: "",
        religion: "",
        citizenship: "",
        nric: "",
        brotherPhoneNo: "",
        officephone: "",
        fatherPhoneNo: "",
    });


    const handleChange = (e) => {
        const { name, value } = e.target;

        console.log(name, value);
        const nricRegex = /^[A-Z]\d{7}[A-Z]$/;

        // Regex to allow only letters and spaces
        const lettersOnlyRegex = /^[a-zA-Z\s]*$/;

        // Regex to allow only numbers
        const onlyNumberRegex = /^[0-9]*$/;

        let errorMessage = "";

        // Check if the field is a text-only field and validate
        if (
            (name === "name" ||
                name === "fatherName" ||
                name === "course" ||
                name === "religion" ||
                name === "citizenship") &&
            !lettersOnlyRegex.test(value)
        ) {
            errorMessage = "Only letters are allowed.";
        }

        if (name === "nric" && value.length === 9 && !nricRegex.test(value)) {
            errorMessage =
                "NRIC must be in the format: 1 capital letter, 7 digits, 1 capital letter (e.g., K1234567H).";
        }

        if (
            (name === "fatherPhoneNo" ||
                name === "officephone") &&
            !onlyNumberRegex.test(value)
        ) {
            errorMessage = "Only numbers are allowed.";
        }

        // Update the error state
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMessage,
        }));

        // If course is selected, find the corresponding currentModule
        if (name === "course") {
            // Find the selected batch details
            const selectedBatch = batches.find((batch) => batch.course === value);
            // setSelectedBatchData(selectedBatch);
            // setInitialModulus(selectedBatch?.currentModule);
            const currentDate = new Date();
            const newModulus = handleDateChange(selectedBatch, currentDate);
            // Update studentData with course, batchId, and currentModule
            setStudentData((prevData) => ({
                ...prevData,
                course: value, // Selected course name
                batchId: selectedBatch?.id || null, // Selected batchId
                startModulus: newModulus || null, // Selected currentModule
            }));
        } else if (!errorMessage) {
            // Update student data only if validation passes
            setStudentData({
                ...studentData,
                [name]: value,
            });
        }
    };


    const handleNricEmailChange = async (e) => {
        const { name, value } = e.target;
        setStudentData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));

        if (value.trim() === "") return;

        if (name === "nric") {
            const nricRegex = /^[STFG]\d{7}[A-Z]$/;
            if (!nricRegex.test(value)) {
                setErrors((prev) => ({ ...prev, [name]: "Invalid NRIC format!" }));
                return;
            }
        } else if (name === "email") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                setErrors((prev) => ({ ...prev, [name]: "Invalid email format!" }));
                return;
            }
        }

        try {
            const response = await axios.get(`/registrationadvances/exists?${name}=${value}`);
            console.log("API Response:", response.data);

            // Adjust this condition to match your API
            if (response.data === true || response.data?.exists === true) {
                setErrors((prev) => ({ ...prev, [name]: `${name.toUpperCase()} already exists!` }));
            }
        } catch (error) {
            console.error(`Error checking ${name}:`, error);

        }
    };




    useEffect(() => {
        // Log the studentData whenever it changes
        console.log('Updated studentData:', studentData);
    }, [studentData]);

    const handleInstitutionChange = (index, e) => {
        const { name, value } = e.target;

        const newInstitutionDetails = studentData.institutionDetails.map((institution, i) => {
            if (i === index) {
                const updatedInstitution = { ...institution, [name]: value };

                // Convert both fields to integers for validation
                const fromYear = parseInt(updatedInstitution.fromYear);
                const toYear = parseInt(updatedInstitution.toYear);

                // Validate only if both years have 4 digits
                if (
                    !isNaN(fromYear) &&
                    !isNaN(toYear) &&
                    updatedInstitution.fromYear.length === 4 &&
                    updatedInstitution.toYear.length === 4
                ) {
                    if (fromYear > toYear) {
                        toast.error("From Year cannot be greater than To Year");
                    }
                }

                return updatedInstitution;
            }
            return institution;
        });

        setStudentData({ ...studentData, institutionDetails: newInstitutionDetails });
    };

    const handleAddEducation = () => {
        setStudentData({
            ...studentData,
            institutionDetails: [
                ...studentData.institutionDetails,
                { institution: '', toYear: '', fromYear: '', qualificationsAchieved: '', country: '', educationCertificateNo: '', },
            ]
        });
    };


    const handleRemoveEducation = (index) => {
        const newInstitutionDetails = studentData.institutionDetails.filter((_, i) => i !== index);
        setStudentData({ ...studentData, institutionDetails: newInstitutionDetails });
    };

    const handleWorkExperienceChange = (index, e) => {
        const { name, value } = e.target;

        const newWorkExperiences = studentData.workExpirences.map((experience, i) => {
            if (i === index) {
                const updatedExperience = { ...experience, [name]: value };

                const fromYear = parseInt(updatedExperience.fromYear);
                const toYear = parseInt(updatedExperience.toYear);

                // Validate only if both years have 4 digits
                if (
                    !isNaN(fromYear) &&
                    !isNaN(toYear) &&
                    updatedExperience.fromYear.length === 4 &&
                    updatedExperience.toYear.length === 4
                ) {
                    if (fromYear > toYear) {
                        toast.error("From Year cannot be greater than To Year in Work Experience");
                    }
                }

                return updatedExperience;
            }
            return experience;
        });

        setStudentData({
            ...studentData,
            workExpirences: newWorkExperiences
        });
    };

    const handleAddWorkExperience = () => {
        setShowEmploymentFields(true);
        setStudentData({
            ...studentData,
            workExpirences: [
                ...studentData.workExpirences,
                { name: '', position: '', toYear: '', fromYear: '', country: '' } // Add a new empty work experience object
            ]
        });
    };

    const handleRemoveWorkExperience = (index) => {

        const newWorkExperiences = studentData.workExpirences.filter((_, i) => i !== index);
        setStudentData({
            ...studentData,
            workExpirences: newWorkExperiences
        });
    };


    const handleFileChange = (setter, allowedTypes, fieldName, allowedFormatsText) => (event) => {
        const file = event.target.files[0];
        if (!file) {
            console.error('No file selected or event is undefined.');
            return;
        }

        if (file.size > 8 * 1024 * 1024) {
            event.target.value = "";
            toast.error("Max file size 8MB");
            return;
        }

        if (!allowedTypes.includes(file.type)) {
            event.target.value = "";
            toast.error(`${fieldName}: Only ${allowedFormatsText}`);
            return;
        }

        setter(file);
    };



    const uploadFile = async (file, publicId) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', CLOUDINARY_UPLOAD);
        formData.append('public_id', publicId + ' - ' + timestamp);

        const response = await fetch(baseURL, {
            method: 'POST',
            body: formData,
        });

        const data = await response.json();
        if (!data.secure_url) {
            throw new Error('Failed to upload file.');
        }
        return data.secure_url;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        setIsUploading(true);
        try {
            const enrollmentDate = new Date().toISOString().split('T')[0];
            const offerDate = new Date().toISOString().split('T')[0];

            const profileUrl = profilePicture
                ? await uploadFile(profilePicture, `LMS/RequestStudent/Profile/${profilePicture.name}`)
                : '';
            const nricdoc = nricDocument
                ? await uploadFile(nricDocument, `LMS/RequestStudent/Nric/${nricDocument.name}`)
                : '';
            const educationdoc = educationDocument
                ? await uploadFile(educationDocument, `LMS/RequestStudent/Education/${educationDocument.name}`)
                : '';
            const passportdoc = passportDocument
                ? await uploadFile(passportDocument, `LMS/RequestStudent/Passport/${passportDocument.name}`)
                : '';

            const updatedStudentData = {
                ...studentData,
                profileUrl,
                nricdoc,
                educationdoc,
                passportdoc,
                enrollmentDate,
                offerDate
            };

            const response = await axios.post('/registrationadvances', updatedStudentData);
            setSubmissionSuccess(true);
            toast.success('Submission successful!');

            setTimeout(() => {
                navigate('/');
            }, 2000);
        } catch (error) {
            console.error('Submission failed:', error);
            toast.error('Submission failed. Please try again.');
        } finally {
            setIsUploading(false);
        }
    };

    const validateForm = () => {
        const requiredFields = [
            'name', 'nric', 'email', 'passport', 'passportExpiryDate',
            'citizenship', 'gender', 'dob', 'martialStatus', 'phone',
            'password', 'currentAddress', 'religion', 'relationship',
            'fatherName', 'fatherPhoneNo', 'type', 'durationType', 'course'
        ];

        for (const field of requiredFields) {
            if (!studentData[field]) {
                toast.error(`Please fill in ${field.replace(/([A-Z])/g, ' $1').toLowerCase()}`);
                return false;
            }
        }

        // Validate NRIC format
        if (!/^[STFG]\d{7}[A-Z]$/i.test(studentData.nric)) {
            toast.error('Invalid NRIC format');
            return false;
        }

        // Validate email format
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(studentData.email)) {
            toast.error('Invalid email format');
            return false;
        }

        // Validate passport expiry date
        if (new Date(studentData.passportExpiryDate) <= new Date()) {
            toast.error('Passport must be valid (future expiry date)');
            return false;
        }

        // Validate work experiences
        for (const exp of studentData.workExpirences) {
            if (!exp.name || !exp.position || !exp.country || !exp.fromYear || !exp.toYear) {
                toast.error('Please fill all required fields in work experience');
                return false;
            }
        }

        // Validate education
        for (const edu of studentData.institutionDetails) {
            if (!edu.institution || !edu.qualificationsAchieved || !edu.educationCertificateNo ||
                !edu.country || !edu.fromYear || !edu.toYear) {
                toast.error('Please fill all required fields in education');
                return false;
            }
        }

        return true;
    };
    const dayMapping = {
        'Sunday': 0,
        'Monday': 1,
        'Tuesday': 2,
        'Wednesday': 3,
        'Thursday': 4,
        'Friday': 5,
        'Saturday': 6
    };

    const handleDateChange = (batch, currentDate) => {

        const newDate = dayjs(currentDate); // Create dayjs object from the new date

        const intakeStartDate = batch?.intakeStartDate ? dayjs(batch.intakeStartDate) : null;
        const isDatePassed = intakeStartDate && newDate.isAfter(intakeStartDate);

        if (batch?.status && !isDatePassed) {

            console.log("Batch is active. Using current module:", batch?.currentModule);
            return batch.currentModule; // Exit function
        }


        const oldDate = dayjs();

        console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
        console.log("New Date:", newDate.format('YYYY-MM-DD'));

        // Calculate the difference in months between the old and new dates
        let monthDifference = newDate.month() - oldDate.month();
        if (newDate.year() !== oldDate.year()) {
            monthDifference += (newDate.year() - oldDate.year()) * 12;
        }
        console.log("Month Difference:", monthDifference);

        // For advance diploma, the increment is simply the month difference
        let increment = monthDifference;
        console.log("Advance Diploma Course - Increment:", increment);

        // Calculate the new modulus value based on the increment
        let newModulus = batch.currentModule + increment;
        // Wrap around to keep it between 1 and 12 (instead of 1 and 6)
        newModulus = ((newModulus - 1) % 12 + 12) % 12 + 1;
        console.log("New Modulus Before Ensuring Range:", newModulus);

        const firstDay = batch.days[0]; // Assuming days is in the correct scope
        console.log("First Day from Data:", firstDay.day);

        const dayIndex = dayMapping[firstDay.day];
        // Determine the first occurrence of the specified day of the month
        const firstOfMonth = newDate.date(1); // Set to the first of the month
        let firstSpecifiedDay = firstOfMonth.day(dayIndex); // Find the first occurrence

        // If the first occurrence is in the previous month, move to the next week
        if (firstSpecifiedDay.isBefore(firstOfMonth)) {
            firstSpecifiedDay = firstSpecifiedDay.add(1, 'week');
        }

        console.log("First Specified Day of the Month:", firstSpecifiedDay.format('YYYY-MM-DD'));

        // Adjust modulus: if the enrollment date is after the first specified day,
        // add 1 to the new modulus.
        if (newDate.isAfter(firstSpecifiedDay)) {
            newModulus += 1;
            console.log("Adjusting Modulus by adding 1.");
        }

        // Ensure modulus value stays within the 1-12 range after adjustments
        newModulus = ((newModulus - 1) % 12 + 12) % 12 + 1;


        console.log("newModulus", newModulus)
        return newModulus;

    };


    const handleCourseTypeChange = (e) => {
        setStudentData({ ...studentData, type: e.target.value });
    };



    return (
        <div>
            <Webhead />

            <Box>
                <Box
                    sx={{
                        backgroundImage: `url(${qq})`, // Uncomment if you are using import
                        // backgroundImage: `url('E:/Desktop/Lider Projects/trent/Trent Internation College/Trent- Frontend/copy/src/website/img/qq.jpeg')`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        py: 8,
                        textAlign: 'center',
                        color: 'white',
                    }}
                >
                    <Typography variant="h2" color="white" sx={{ fontWeight: 700 }}>
                        Online Student Portal
                    </Typography>
                </Box>
                <br />
                <div className="containerd" style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', backgroundColor: '#f9f9f9' }}>
                    <h2 className="text-center mb-4" style={{ color: '#333', marginBottom: '30px' }}>Online Registration Form</h2>
                    <form onSubmit={handleSubmit}>
                        {/* Full Name, NRIC, Email */}
                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label htmlFor="Name" className="form-label">Name*</label>
                                <input
                                    type="text"
                                    id="name"
                                    className="form-control"
                                    name="name"
                                    value={studentData.name}
                                    onChange={handleChange}
                                    required
                                    placeholder="Enter your Full Name"
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                />
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="proofType" className="form-label">Proof Type *</label>
                                <select
                                    id="proofType"
                                    className="form-control"
                                    name="proofType"
                                    value={studentData.proofType || ""}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                >
                                    <option value="">Select Proof Type</option>
                                    <option value="NRIC">NRIC</option>
                                    <option value="FIN">FIN</option>
                                </select>
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="nric" className="form-label">NRIC/FIN No*</label>
                                <input
                                    type="text"
                                    id="nric"
                                    className="form-control"
                                    name="nric"
                                    value={studentData.nric}
                                    onChange={handleNricEmailChange}
                                    required
                                    placeholder="Enter your NRIC"
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                    maxLength={9}
                                />
                                {errors.nric && <p style={{ color: "red" }}>{errors.nric}</p>}
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label htmlFor="email" className="form-label">Email*</label>
                                <input
                                    type="email"
                                    id="email"
                                    className="form-control"
                                    name="email"
                                    value={studentData.email}
                                    onChange={handleNricEmailChange}
                                    required
                                    placeholder="Enter your email"
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                    maxLength={100}
                                />
                                {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="Passport Number" className="form-label">Passport Number*</label>
                                <input
                                    type="text"
                                    id="fullname"
                                    className="form-control"
                                    name="passport"
                                    value={studentData.passport}
                                    onChange={handleChange}
                                    required
                                    placeholder="Enter your passport"
                                    maxLength={8}
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="nric" className="form-label">Passport ExpiryDate*</label>
                                <input
                                    type="date"
                                    id="fullname"
                                    className="form-control"
                                    name="passportExpiryDate"
                                    value={studentData.passportExpiryDate}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label htmlFor="citizen" className="form-label">Nationality*</label>
                                <input
                                    type="text"
                                    id="citizenship"
                                    className="form-control"
                                    name="citizenship"
                                    value={studentData.citizenship}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="type">Course Type</label>
                                <select
                                    id="type"
                                    className="form-control"
                                    name="type"
                                    value={studentData.type || ""}
                                    onChange={handleCourseTypeChange}
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                >
                                    <option value="">Select Course Type</option>
                                    <option value="diploma">Diploma</option>
                                    <option value="advance_diploma">Advanced Diploma</option>
                                </select>
                                {errors.type && <p style={{ color: "red" }}>{errors.type}</p>}
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="durationType">Duration Type *</label>
                                <select
                                    id="durationType"
                                    className="form-control"
                                    name="durationType"
                                    value={studentData.durationType || ""}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                >
                                    <option value="">Select Course Type</option>
                                    <option value="part_time">Part Time</option>
                                    <option value="full_time">Full TIme</option>
                                </select>
                                {errors.durationType && <p style={{ color: "red" }}>{errors.durationType}</p>}
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label htmlFor="course">Course *</label>
                                <select
                                    id="course"
                                    className="form-control"
                                    name="course"
                                    value={studentData.course}
                                    onChange={handleChange}
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                    required
                                >
                                    <option value="">Select Course...</option>
                                    {batches.map((batch) => (
                                        <option key={batch.id} value={batch.course}>
                                            {batch.course}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="gender" className="form-label">Gender*</label>
                                <select
                                    id="gender"
                                    className="form-control"
                                    name="gender"
                                    value={studentData.gender}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                >
                                    <option value="">Select...</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="dob" className="form-label">Date of Birth*</label>
                                <input
                                    type="date"
                                    id="dob"
                                    className="form-control"
                                    name="dob"
                                    value={studentData.dob}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label htmlFor="martialStatus" className="form-label">Marital Status *</label>
                                <select
                                    id="martialStatus"
                                    className="form-control"
                                    name="martialStatus"
                                    value={studentData.martialStatus || ""}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                >
                                    <option value="">Select Marital Status</option>
                                    <option value="single">Single</option>
                                    <option value="married">Married</option>
                                    <option value="divorced">Divorced</option>
                                    <option value="widowed">Widowed</option>
                                </select>
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="Hand Phone" className="form-label">Hand Phone*</label>
                                <input
                                    type="tel"
                                    id="phone"
                                    className="form-control"
                                    name="phone"
                                    value={studentData.phone}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                    maxLength={8}
                                />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="Office Phone" className="form-label">Office Phone</label>
                                <input
                                    type="tel"
                                    id="phone"
                                    className="form-control"
                                    name="officephone"
                                    value={studentData.officephone}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                    maxLength={8}
                                />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label htmlFor="password" className="form-label">Password*</label>
                                <input
                                    type="password"
                                    id="password"
                                    className="form-control"
                                    name="password"
                                    value={studentData.password}
                                    onChange={handleChange}
                                    required
                                    maxLength={12}
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="Singapore address" className="form-label">Singapore address *</label>
                                <input
                                    type="text"
                                    id="address"
                                    className="form-control"
                                    name="currentAddress"
                                    value={studentData.currentAddress}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="Home Address" className="form-label">Home Address</label>
                                <input
                                    type="text"
                                    id="address"
                                    className="form-control"
                                    name="address"
                                    value={studentData.address}
                                    onChange={handleChange}
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label htmlFor="race" className="form-label">Religion*</label>
                                <input
                                    type="text"
                                    id="race"
                                    className="form-control"
                                    name="religion"
                                    value={studentData.religion}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                />
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="relationship" className="form-label">Relationship*</label>
                                <input
                                    type="text"
                                    id="relationship"
                                    className="form-control"
                                    name="relationship"
                                    value={studentData.relationship}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                />
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="address" className="form-label">Emergency Contact Name*</label>
                                <input
                                    type="text"
                                    id="address"
                                    className="form-control"
                                    name="fatherName"
                                    value={studentData.fatherName}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label htmlFor="address" className="form-label">Emergency Contact Number*</label>
                                <input
                                    type="text"
                                    id="address"
                                    className="form-control"
                                    name="fatherPhoneNo"
                                    value={studentData.fatherPhoneNo}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                    maxLength={10}
                                />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="profileUpload" className="form-label">Upload Photo*</label>
                                <input
                                    type="file"
                                    id="profileUpload"
                                    required
                                    className="form-control"
                                    accept="image/png, image/jpeg, image/jpg"
                                    onChange={handleFileChange(
                                        setProfilePicture,
                                        ['image/png', 'image/jpeg', 'image/jpg'],
                                        "Profile Photo",
                                        "PNG, JPG, JPEG"
                                    )}
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="nricUpload" className="form-label">Upload NRIC</label>
                                <input
                                    type="file"
                                    id="nricUpload"
                                    className="form-control"
                                    accept="application/pdf"
                                    onChange={handleFileChange(
                                        setNricDocument,
                                        ['application/pdf'],
                                        "NRIC Document",
                                        "PDF"
                                    )}
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label htmlFor="educationUpload" className="form-label">Upload Education</label>
                                <input
                                    type="file"
                                    id="educationUpload"
                                    className="form-control"
                                    accept="application/pdf"
                                    onChange={handleFileChange(
                                        setEducationDocument,
                                        ['application/pdf'],
                                        "Education Document",
                                        "PDF"
                                    )}
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="passportUpload" className="form-label">Upload Passport</label>
                                <input
                                    type="file"
                                    id="passportUpload"
                                    className="form-control"
                                    accept="application/pdf"
                                    onChange={handleFileChange(
                                        setPassportDocument,
                                        ['application/pdf'],
                                        "Passport Document",
                                        "PDF"
                                    )}
                                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ced4da', height: '42px' }}
                                />
                            </div>
                        </div>

                        <div>

                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: '20px', // You can adjust the gap value as needed
                                    margin: '10px 0',
                                }}
                            >
                                <button
                                    type="button"
                                    onClick={handleAddWorkExperience}
                                    style={{
                                        padding: '10px 20px',
                                        fontSize: '16px',
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        borderRadius: '8px',
                                        border: 'none',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease',
                                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    + Add Employment
                                </button>

                                <button
                                    type="button"
                                    onClick={handleAddEducation}
                                    style={{
                                        padding: '10px 20px',
                                        fontSize: '16px',
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        borderRadius: '8px',
                                        border: 'none',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease',
                                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    + Add Education
                                </button>
                            </Box>

                            <div className="row mb-3">




                                {/* Employment Status Fields */}
                                {showEmploymentFields && (
                                    studentData.workExpirences.map((experience, index) => (
                                        <div key={index} style={{ marginBottom: '15px', padding: '10px', border: '1px solid #ced4da', borderRadius: '6px' }} >
                                            <div className="form-group">
                                                <label htmlFor={`companyname-${index}`}>Company Name*</label>
                                                <input
                                                    type="text"
                                                    id={`companyname-${index}`}
                                                    style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                                    className="form-control"
                                                    name="name"
                                                    value={experience.name}
                                                    onChange={(e) => handleWorkExperienceChange(index, e)}
                                                    required
                                                />
                                            </div>

                                            <div className="form-group" style={{ display: 'flex', gap: '16px' }}>
                                                <div style={{ flex: 1 }}>
                                                    <label htmlFor={`position-${index}`}>Position*</label>
                                                    <input
                                                        type="text"
                                                        id={`position-${index}`}
                                                        style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                                        className="form-control"
                                                        name="position"
                                                        value={experience.position}
                                                        onChange={(e) => handleWorkExperienceChange(index, e)}
                                                        required
                                                    />
                                                </div>

                                                <div style={{ flex: 1 }}>
                                                    <label htmlFor={`country-${index}`}>Country *</label>
                                                    <input
                                                        type="text"
                                                        id={`country-${index}`}
                                                        className="form-control"
                                                        name="country"
                                                        value={experience.country}
                                                        onChange={(e) => handleWorkExperienceChange(index, e)}
                                                        style={{
                                                            width: '100%',
                                                            height: '42px',
                                                            borderRadius: '6px',
                                                            border: '1px solid #ced4da'
                                                        }}
                                                        required
                                                    />
                                                </div>

                                            </div>



                                            <div className="form-group" style={{ display: 'flex', gap: '16px' }}>
                                                {/* From Year */}
                                                <div style={{ flex: 1 }}>
                                                    <label htmlFor={`fromYear-${index}`}>From Year *</label>
                                                    <input
                                                        type="number"
                                                        id={`fromYear-${index}`}
                                                        className="form-control"
                                                        name="fromYear"
                                                        value={experience.fromYear}
                                                        onChange={(e) => handleWorkExperienceChange(index, e)}
                                                        style={{
                                                            width: '100%',
                                                            height: '42px',
                                                            borderRadius: '6px',
                                                            border: '1px solid #ced4da'
                                                        }}
                                                        required
                                                    />
                                                </div>

                                                {/* To Year */}
                                                <div style={{ flex: 1 }}>
                                                    <label htmlFor={`toYear-${index}`}>To Year *</label>
                                                    <input
                                                        type="number"
                                                        id={`toYear-${index}`}
                                                        className="form-control"
                                                        name="toYear"
                                                        value={experience.toYear}
                                                        onChange={(e) => handleWorkExperienceChange(index, e)}
                                                        style={{
                                                            width: '100%',
                                                            height: '42px',
                                                            borderRadius: '6px',
                                                            border: '1px solid #ced4da'
                                                        }}
                                                        required
                                                    />
                                                </div>

                                                {/* Country */}

                                            </div>

                                            {/* Button to remove the work experience entry */}
                                            <button
                                                type="button"
                                                onClick={() => handleRemoveWorkExperience(index)}
                                                style={{
                                                    margin: '10px 0',
                                                    padding: '5px 15px',
                                                    fontSize: '16px',
                                                    backgroundColor: 'red',
                                                    color: 'white',
                                                    borderRadius: '8px',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    transition: 'background-color 0.3s ease',
                                                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                                }}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    )))}




                                {studentData.institutionDetails.map((institution, index) => (
                                    <div key={index} style={{ marginBottom: '15px', padding: '10px', border: '1px solid #ced4da', borderRadius: '6px' }}>
                                        <div className="form-group">
                                            <label htmlFor={`institution-${index}`}>Institution Name*</label>
                                            <input
                                                type="text"
                                                id={`institution-${index}`}
                                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                                className="form-control"
                                                name="institution"
                                                value={institution.institution}
                                                onChange={(e) => handleInstitutionChange(index, e)}
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor={`degree-${index}`}>Degree*</label>
                                            <input
                                                type="text"
                                                id={`qualificationsAchieved-${index}`}
                                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                                className="form-control"
                                                name="qualificationsAchieved"
                                                value={institution.qualificationsAchieved}
                                                onChange={(e) => handleInstitutionChange(index, e)}
                                                required
                                            />
                                        </div>
                                        <div className="form-group" style={{ display: 'flex', gap: '16px' }}>

                                            {/* Education Certificate Number */}
                                            <div style={{ flex: 1 }}>
                                                <label htmlFor={`educationCertificateNo-${index}`}> Certificate Number * </label>
                                                <input
                                                    type="text"
                                                    id={`educationCertificateNo-${index}`}
                                                    style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                                    className="form-control"
                                                    name="educationCertificateNo"
                                                    value={institution.educationCertificateNo}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    required
                                                />
                                            </div>

                                            <div style={{ flex: 1 }}>
                                                <label htmlFor={`country-${index}`}> Country * </label>
                                                <input
                                                    type="text"
                                                    id={`country-${index}`}
                                                    style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                                    className="form-control"
                                                    name="country"
                                                    value={institution.country}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    required
                                                />
                                            </div>


                                        </div>

                                        {/* From Year */}
                                        <div className="form-group" style={{ display: 'flex', gap: '16px' }}>
                                            {/* From Year */}
                                            <div style={{ flex: 1 }}>
                                                <label htmlFor={`fromYear-${index}`}>From Year *</label>
                                                <input
                                                    type="number"
                                                    id={`fromYear-${index}`}
                                                    className="form-control"
                                                    name="fromYear"
                                                    value={institution.fromYear}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    style={{
                                                        width: '100%',
                                                        height: '42px',
                                                        borderRadius: '6px',
                                                        border: '1px solid #ced4da'
                                                    }}
                                                    required
                                                />
                                            </div>

                                            {/* To Year */}
                                            <div style={{ flex: 1 }}>
                                                <label htmlFor={`toYear-${index}`}>To Year *</label>
                                                <input
                                                    type="number"
                                                    id={`toYear-${index}`}
                                                    className="form-control"
                                                    name="toYear"
                                                    value={institution.toYear}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    style={{
                                                        width: '100%',
                                                        height: '42px',
                                                        borderRadius: '6px',
                                                        border: '1px solid #ced4da'
                                                    }}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            onClick={() => handleRemoveEducation(index)}
                                            style={{
                                                margin: '10px 0',
                                                padding: '5px 15px',
                                                fontSize: '16px',
                                                backgroundColor: 'red',
                                                color: 'white',
                                                borderRadius: '8px',
                                                border: 'none',
                                                cursor: 'pointer',
                                                transition: 'background-color 0.3s ease',
                                                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                            }}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                ))}



                            </div>

                        </div>

                        {/* Submit Button */}
                        <button type="submit" className="btn btn-primary" disabled={isUploading} style={{ width: '100%', padding: '10px', fontSize: '16px', borderRadius: '5px', border: 'none', backgroundColor: '#007bff', color: '#fff', cursor: 'pointer', transition: 'background-color 0.3s ease' }}>
                            {isUploading ? 'Uploading...' : 'Submit'}
                        </button>
                    </form>

                    <Dialog
                        open={open}
                        onClose={() => setOpen(false)}
                        maxWidth="sm"
                        PaperProps={{ style: { borderRadius: 15, overflow: 'hidden' } }}
                    // disableBackdropClick
                    >
                        <DialogContent>
                            {submissionSuccess ? (
                                <Slide direction="up" in={submissionSuccess} mountOnEnter unmountOnExit>
                                    <Box textAlign="center" py={4}>
                                        <CheckCircleIcon style={{ fontSize: 60, color: 'green' }} />
                                        <Typography variant="h5" gutterBottom>
                                            Form Submitted Successfully!, You will receive an email once you application is Approved
                                        </Typography>
                                        <Typography variant="body1" color="textSecondary">
                                            You will be redirected to the home page shortly.
                                        </Typography>
                                    </Box>
                                </Slide>
                            ) : (
                                <Box textAlign="center" py={4}>
                                    <CircularProgress />
                                    <Typography variant="h6" style={{ marginTop: 20 }}>
                                        Submitting Your Form...
                                    </Typography>
                                </Box>
                            )}
                        </DialogContent>
                    </Dialog>
                    <ToastContainer />
                </div>

            </Box>
            <Webfooter />
        </div>
    );
};

export default Elearn;
